<ngx-datatable
    [rows]="rows"
    [columns]="columns"
    columnMode="force"
    [footerHeight]="100"
    [headerHeight]="50"
    rowHeight="auto"
>
    <ngx-datatable-footer *ngIf="true">
        <ng-template
            ngx-datatable-footer-template
            let-rowCount="rowCount"
            let-pageSize="pageSize"
            let-selectedCount="selectedCount"
            let-curPage="curPage"
            let-offset="offset"
        >
            <div style="padding: 5px 10px">
                <div><strong>Summary</strong>: Gender: Female</div>
                <hr style="width:100%" />
                <div>Rows: {{ rowCount }} | Size: {{ pageSize }} | Current: {{ curPage }} | Offset: {{ offset }}</div>
            </div>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>